export default "__VITE_ASSET__ytbdnPRC__"